import { Platform } from '@wix/ambassador-headless-businesssetup-v1-no-entity/types';

export const SUPPORTED_PLATFORMS = [Platform.BASE44, Platform.LOVABLE];
